'use client';

import Alert from '@/ui/alert';
import { Button } from '@/ui/button';
import Header from '@/ui/header';
import { captureException } from '@sentry/nextjs';
import type Error from 'next/error';
import { useState } from 'react';
import { useEffect } from 'react';
export default function GlobalError({
  error,
  reset
}: {
  error: Error & {
    message?: string;
    digest?: string;
  };
  reset: () => void;
}) {
  const [sentryErrorId, setSentryErrorId] = useState<string | undefined>(undefined);
  useEffect(() => {
    setSentryErrorId(captureException(error));
  }, [error]);
  const serverError = 'An error occured in the Server Components render';
  return <html data-sentry-component="GlobalError" data-sentry-source-file="global-error.tsx">
      <body>
        <div className="mx-auto flex max-w-3xl flex-col justify-center gap-6 px-6 py-24 relative">
          <Header data-sentry-element="Header" data-sentry-source-file="global-error.tsx" />

          <Alert variant="destructive" title="Uh oh, something went wrong!" buttons={<Button size="small" onClick={() => reset()}>
                Try again
              </Button>} description={<div className="flex flex-col">
                <p>Try again later, or send us your feedback if this problem continues to occur.</p>
                {sentryErrorId && <p>Id: {sentryErrorId}</p>}
                {error.digest && <p>Details: {error.digest}</p>}
                {error.message && !error.message.includes(serverError) && <p>{error.message}</p>}
              </div>} data-sentry-element="Alert" data-sentry-source-file="global-error.tsx" />
        </div>
      </body>
    </html>;
}